import { httpCreate } from './http';
import config from '@services/config';
import QueryString from 'qs';

const http = httpCreate('/um/fission-group');

export const fissionGroup = {
	/** 修改入群欢迎语设置
	 * @param { Number } data.enterTextFlag 入群欢迎语开关
	 * @param { String } data.enterText 入群欢迎语内容
	 * @param { Number } data.enterImgFlag 入群欢迎语图片开关
	 * @param { String } data.enterImg 入群欢迎语图片
	 * @param { Number } data.enterLinkFlag 入群欢迎链接开关
	 * @param { String } data.enterLinkTitle 入群欢迎链接标题
	 * @param { String } data.enterLinkImg 入群欢迎链接图片
	 * @param { String } data.enterLinkUrl 入群欢迎链接地址
	 * @returns
	 */
	updateEnterSetting(groupId, data) {
		return http.put(`/${groupId}`, data);
	},
	/** 获取群聊列表
	 * @param { Number } params.pageNum 页码
	 * @param { Number } params.pageSize 页容量
	 * @param { String } params.gName 搜索标题
	 * @returns
	 */
	getList(fissionId, params) {
		return http.get(`/page/${fissionId}`, { params });
	},
	// 获取欢迎语详情
	getFissionInfo(fissionId, groupId) {
		return http.get(`/${fissionId}/${groupId}`);
	},

	/** 获取群聊列表
	 * @param { Number } params.nickname 昵称
	 * @param { Number } params.inviteNickname 邀请人昵称
	 * @param { String } params.status 状态 0 退群 1 正常 不传全部
	 * @param { Number } params.pageNum 页码
	 * @param { Number } params.pageSize 页容量
	 * @param { Number } params.groupId 所属群组
	 * @returns
	 */
	getMemberList(fissionId, params) {
		return http.get(`/member/page/${fissionId}`, { params });
	},
	// 获取群详情
	getInfo(groupId) {
		return http.get(`/${groupId}`);
	},
	// 导出群聊数据
	exportFile(fissionId, params) {
		const query = QueryString.stringify(params);
		return `${config.host}/um/fission-group/export-excel/${fissionId}${query ? '?' + query : ''}`;
	},
};
